import * as z from "zod/v4";

const BatchProductSchema_ = z.object({
  productId: z.string(),
  title: z.string(),
  sku: z.string().nullable(),
  imageUrl: z.string().nullable(),
});

const BatchPickLineSchema_ = BatchProductSchema_.extend({
  quantityRequired: z.number().int(),
});

const BatchWorkOrderSchema_ = z.object({
  id: z.string(),
  status: z.string(),
  currentStepId: z.string().nullish(),
  currentStepTitle: z.string().nullish(),
  bomId: z.string().nullable(),
  bomName: z.string().nullable(),
  fulfillmentGroupId: z.string().nullable(),
  externalOrderName: z.string().nullable(),
  inputs: z.array(BatchPickLineSchema_),
  output: BatchProductSchema_.nullable(),
  suggestedBin: z.object({ id: z.string(), name: z.string() }).nullable(),
  lineItemCustomAttributes: z
    .array(z.object({ key: z.string(), value: z.string().nullable() }))
    .nullable(),
});
export const BatchWorkOrderSchema: z.ZodType<BatchWorkOrder> =
  BatchWorkOrderSchema_;
export interface BatchWorkOrder extends z.infer<typeof BatchWorkOrderSchema_> {}

const BatchFlowStepSchema_ = z.object({
  id: z.string(),
  title: z.string(),
  type: z.string(),
  nextId: z.string().nullable().optional(),
  stationId: z.string().nullable().optional(),
  displayAttributes: z
    .array(z.object({ label: z.string(), attributeKey: z.string() }))
    .optional(),
});
export const BatchFlowStepSchema: z.ZodType<BatchFlowStep> =
  BatchFlowStepSchema_;
export interface BatchFlowStep extends z.infer<typeof BatchFlowStepSchema_> {}

const WorkOrderBatchDetailSchema_ = z.object({
  id: z.string(),
  title: z.string().nullable(),
  triggerKind: z.string().nullable(),
  flowId: z.string(),
  flowName: z.string().nullable(),
  status: z.string(),
  workOrderCount: z.number().int(),
  locationId: z.string(),
  createdAt: z.coerce.date(),
  sessionId: z.string().nullable(),
  placeStationId: z.string().nullable(),
});
export const WorkOrderBatchDetailSchema: z.ZodType<WorkOrderBatchDetail> =
  WorkOrderBatchDetailSchema_;
export interface WorkOrderBatchDetail
  extends z.infer<typeof WorkOrderBatchDetailSchema_> {}

export const getWorkOrderBatch = {
  name: "getWorkOrderBatch" as const,
  input: z.object({ batchId: z.string() }),
  output: z.object({
    batch: WorkOrderBatchDetailSchema.nullable(),
    workOrders: z.array(BatchWorkOrderSchema),
    flowSteps: z.array(BatchFlowStepSchema),
  }),
};
